import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar15Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar15 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar15Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar15">
        <G id="Group 1538228682">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="Vector"
            d="M147.598 246.958c-35.484-5.624-57.01.516-72.088 2.541-13.003 1.748-23.004 5.418-30.701 10.025 27.453 27.278 65.264 44.143 107.023 44.143 32.291 0 62.23-10.089 86.839-27.279-27.008-11.812-66.527-25.538-91.065-29.423l-.008-.007Z"
            fill="#000"
          />
          <G id="Group">
            <Path
              id="skin"
              d="M230.388 160.937c.46-7.809-.898-10.756-.898-25.054.699-46.597-19.199-87.197-57.162-87.721-79.817-1.104-61.801 78.212-61.594 80.548-5.569-5.569-25.483 1.112-15.983 20.121 9.12 18.238 17.889 27.047 25.11 21.972-.929 16.745-5.227 46.12-6.482 53.086-2.669 14.807-19.652 22.099-19.652 22.099s60.426 58.926 92.201 53.707c3.836-.628 22.257-25.332-6.133-48.043-2.637-2.113 3.328-23.513 4.012-35.381 8.428 1.581 18.461 4.06 24.871-2.255 6.681-13.767 20.987-41.013 21.694-53.071l.016-.008Z"
              fill={c.skin}
            />
            <Path
              id="Vector_2"
              opacity={0.75}
              d="M181.177 234.764c.747-6.856 2.629-18.93 2.224-19.025-22.083-4.933-39.281-18.461-44.539-23.33 0 .452 15.331 36.89 42.315 42.355Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_3"
              opacity={0.75}
              d="M179.977 176.347c.699.842 10.136 15.959 21.948 16.316 10.065.302 14.187-11.24 14.473-11.82 0 0-4.051-5.417-7.149-5.513-3.098-.095-5.378 1.573-5.378 1.573s-2.629-2.2-5.91-2.295c-3.28-.096-6.354 1.731-9.468 2.121-3.146.389-8.524-.374-8.524-.374l.008-.008Zm4.067 2.606c-.079-.064 0-.167.096-.119 3.63 1.89 10.056 3.479 20.176 3.789 5.211.159 8.667.214 11.59-.707-2.939 1.191-6.959 4.694-12.162 4.535-10.144-.309-16.173-4.829-19.708-7.49l.008-.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_4"
              opacity={0.75}
              d="M196.723 161.826c-.596 2.328 2.28 3.877 12.17 3.48 8.142-.326 10.763-4.743 9.166-5.362-1.596-.62-3.733 2.153-9.039 2.153-7.729 0-11.693-2.606-12.297-.279v.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_5"
              d="M150.737 120.226s12.654-3.98 22.489-3.909c11.557.08 19.684 7.817 21.908 3.861.707-1.255.222-7.872-20.844-10.041-9.429-.969-14.974 3.456-23.553 10.089Z"
              fill="#000"
            />
            <Path
              id="Vector_6"
              d="M191.091 135.493c-2.852-4.877-7.578-9.365-13.512-10.454-2.677-.317-5.378-.008-7.92.977-2.081.795-3.686 2.113-5.227 3.432-2.089 1.446-4.861.898-7.379.604 2.375 1.66 5.886 2.994 8.777 1.565a25.738 25.738 0 0 1 2.01-1.176c-.016.206-.04.421-.04.627 0 3.877 3.249 7.015 7.261 7.015 4.011 0 7.26-3.138 7.26-7.015a7.29 7.29 0 0 0-.071-.937c2.844 1.303 5.703 3.241 8.849 5.362h-.008Z"
              fill="#000"
            />
            <Path
              id="Vector_7"
              d="M228.331 113.267c-13.822-.414-20.058 7.252-18.572 10.096.921 1.763 3.733 1.835 5.822-.159 5.704-4.893 7.388-3.257 13.362-3.336-.104-2.082-.406-4.862-.612-6.601Z"
              fill="#000"
            />
            <Path
              id="Vector_8"
              d="M236.035 131.958c-1.541-1.319-3.146-2.637-5.227-3.432-2.542-.985-5.251-1.287-7.92-.977-5.934 1.088-10.66 5.584-13.512 10.454 1.613-1.088 3.154-2.129 4.655-3.058.278 3.407 3.217 6.092 6.816 6.092 3.781 0 6.847-2.963 6.847-6.617 0-1.239-.373-2.391-.993-3.384 2.447.27 5.044 1.224 7.936 3.082 2.883 1.43 6.402.096 8.777-1.564-2.518.294-5.29.842-7.379-.604v.008Z"
              fill="#000"
            />
            <Path
              id="hair"
              d="m202.72 260.644-3.369-17.571s9.835 5.822 6.284 17.301c6.648-5.187.365-33.323.365-33.323s13.576 17.174 22.735 5.965c-6.427-1.914-13.123-5.06-12.17-15.315 3.146 1.231 6.156 7.658 6.156 7.658s-5.608-26.325 1.915-31.107c3.558 8.34 1.914 12.852 13.123 14.354-5.196-6.697-10.526-17.23-7.658-25.023 2.868-7.792 5.648-11.947 7.546-14.957 1.899-3.011 3.162-9.763 3.162-9.763s1.263 6.228-.191 10.605c4.083-3.305 11.24-24.514 6.887-31.584-4.353-7.07-10.167-9.397-4.083-5.33 6.077 4.059 9.525 11.677 8.071 18.747 5.616-9.421 4.71-21.027-5.259-25.555-9.969-4.528 9.938-4.281 9.938-15.402-7.022 4.345-9.977 1.167-11.717-5.06-1.74-6.228-11.351-62.016-53.516-71.747-30.336-7.006-39.988 1.962-39.988 1.962s-28.033-14.123-58.806 13.282c-30.773 27.405-16.904 67.878-43.014 61.88 3.876 5.497 14.115 5.497 14.115 5.497s-23.489 16.491-11.74 32.235c3.495-7.745 4.75-11.74 4.75-11.74s-1.938 28.462 5.942 36.786c1.31-3.503-.437-15.116-.437-15.116s20.59 28.914-7.451 29.788c3.066 2.407 14.672 3.066 14.672 3.066s-7.332 10.518-15.347 8.357c8.015 8.444 15.593 3.249 15.593 3.249s-5.45 11.32-3.082 17.023c3.892-.413 13.345-6.808 13.345-6.808s-5.64 9.318-4.409 14.466c1.232 5.147 3.186 11.764-4.408 11.764 3.924 4.17 10.54 1.962 13.233-.739 2.693-2.693-.182 7.626-1.977 11.82-1.796 4.195 22.17-8.086 23.068-8.992.897-.897 13.734 6.689 6.339 13.282 7.721.484.627-15.705 2.359-22.067 5.815-21.376 6.18-61.738 6.18-61.738s-10.811 6.951-21.757-16.459c-10.955-23.417 6.672-36.628 18.381-20.518.882 18 1.382 24.172 6.291 27.691 4.909 3.519 6.8 19.383 6.8 19.383s4.409-24.8.628-34.11c4.782 2.891 7.927 11.081 13.972 5.918-3.773-1.764-13.091-8.611-11.883-17.476 1.207-8.865 25.379-13.091 31.218-27.191 5.838-14.1 7.451-20.542 7.451-20.542s3.018 17.317-1.207 24.57c6.442-4.433 11.478-16.515 11.478-16.515s-1.009 12.686-5.036 16.316c-4.028 3.622-14.807 11.145-2.971 4.464 11.836-6.68 20.701-23.195 18.278-39.305 7.856 7.65 6.649 25.777 1.009 35.246 4.631 2.82 10.47 4.631 17.118-.199 6.649-4.837 9.469-18.127 9.469-18.127s8.793 14.91 9.143 20.447c.318 4.981.453 15.657 1.112 25.356.659 9.699 1.74 18.643-1.549 30.559-3.066 11.113-17.817 43.395-22.909 46.279-5.441 3.082-21.074-.31-21.074-.31l-3.599 19.708-1.326 14.815 23.822 9.858-.015-.008Z"
              fill={c.hair}
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};
